import _merge from 'lodash/merge'
// import Token from '../../token'
import { registerRouteEvent } from '../../router/proxy'
import httpInstance from './http-instance'
import RequestCancel from './request-cancel'
import RequestCache from './request-cache'
import { findApi, getApiConfig } from '../config'

const requestCancel = new RequestCancel()
const requestCache = new RequestCache()
const AppConfig = getApiConfig()

// 路由变化时取消所有请求
registerRouteEvent('beforeEach', (to, from, next) => {
  if (to.path !== from.path) {
    requestCancel.cancel({
      message: 'Cancel all requests when routing changes',
      hidden: true
    })
  }
  next()
})

async function httpDispatch (name, config, host) {
  // 请求配置
  const httpConfig = await getHttpConfig(name, config, host)

  // 使用缓存
  if (httpConfig._useCache) {
    const _cache = requestCache.get(httpConfig)
    if (_cache) return _cache.request
  }

  // 创建请求
  const httpRequest = getHttpRequest(httpConfig)

  // 添加缓存
  if (httpConfig._useCache) requestCache.add(httpConfig, httpRequest)

  return httpRequest
}

async function getHttpConfig (name, config, host) {
  // api 配置
  const apiConfig = findApi(name)
  if (!apiConfig) throw new Error(`httpDispatch 没有找到对应的请求配置; name: ${name}`)

  // 请求配置
  const httpConfig = _merge({
    headers: {
      'Content-Type': 'application/json'
    }
  }, apiConfig.config, config || {})

  // 添加 accessToken
  // httpConfig.headers.accessToken = await Token.getToken()

  // 添加 cancelToken
  // if (!httpConfig.cancelToken && !httpConfig._noCancel) {
  //   httpConfig.cancelToken = requestCancel.token
  // }

  // url 处理
  httpConfig.url = AppConfig[host || 'host'] + httpConfig.url
  // httpConfig.url = AppConfig['host'] + httpConfig.url

  return httpConfig
}

function getHttpRequest (config) {
  return httpInstance(config).then(response => {
    const data = response && response.data
    // 平台接口数据格式处理
    if (data && data.code === 0) return data.data

    // 接口数据异常处理
    const message = data && (data.msg || data.message)

    // 提示报错信息
    if (config._showMessage || config._showMessage === undefined) {
      //todo 根据业务使用ui框架，替换错误提示
      if (message) setTimeout(() => console.error(data.msg), 100)
    }

    // 抛出异常数据
    throw Object.assign(data, { message })
  }).catch(error => {
    // 提示服务器异常信息
    if (config._showMessage || config._showMessage === undefined) {
      const data = error && error.response && error.response.data
      const message = data && (data.msg || data.message)
      // 如果设置了 message.hidden 则不提示
      if (!(error && error.message && error.message.hidden)) {
        setTimeout(() => console.error(message || '服务器异常'), 100)
         //todo 根据业务使用ui框架，替换错误提示
      }
    }
    throw error
  })
}

export default httpDispatch
export {
  requestCancel,
  requestCache
}
